import { QueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

import { useQueryClientStore } from '../lib/store';

export const QueryProvider: FC<PropsWithChildren> = (props) => {
	const client = useQueryClientStore((state) => state.queryClient);

	return <QueryClientProvider client={client} {...props} />;
};
